import { Button } from '@economic/taco';
import { Trans } from '@lingui/macro';
import { FormApi } from 'final-form';
import React, { useEffect, useRef } from 'react';
import { Field } from '~/app/shared/components/Form';
import AmountInput from '~/app/shared/components/ui/AmountInput';
import number from '~/app/shared/util/utilities/number';
import { PartialInvoicingViewLineDto } from '~/types/internal-api';

interface Props {
    row: PartialInvoicingViewLineDto;
    form: FormApi;
}

export default function QuantityForInvoicingInputHandler({ row, form }: Props) {
    const numberFieldValueRef = useRef<string | null>(null);

    useEffect(() => {
        return () => {
            // Anything in here is fired on component unmount.
            if (numberFieldValueRef.current !== null) {
                const numberValue = number.parse(numberFieldValueRef.current);
                form.change(`newQuantity-${row.lineId}`, numberValue);
                form.blur(`newQuantity-${row.lineId}`);
            }
        };
    }, [form, row.lineId]);

    const handleOnKeyUp = (e: { target: { value: string | null } }) => {
        numberFieldValueRef.current = e.target.value;
    };

    return (
        <div className="w-full">
            <Field.Number
                hideLabel
                name={`newQuantity-${row.lineId}`}
                disabled={row.quantity - row.alreadyInvoiced <= 0}
                as={AmountInput}
                fieldClassName="w-full"
                onKeyUp={handleOnKeyUp}
                postfix={
                    row.quantity - row.alreadyInvoiced > 0 ? (
                        <Button
                            appearance="discrete"
                            onClick={() => {
                                form.change(`newQuantity-${row.lineId}`, row.quantity - row.alreadyInvoiced);
                                form.blur(`newQuantity-${row.lineId}`);
                            }}>
                            <Trans>balance</Trans>
                        </Button>
                    ) : undefined
                }
            />
        </div>
    );
}
